export default __webpack_public_path__ + "static/ultrasonic-reflectoscope-controller-c922e7875989ade9b2aa935815b9e64a.jpg";